import userRequests from './user/user'

export default {
  ...userRequests,
}
